import { render, staticRenderFns } from "./DxfLayersList.vue?vue&type=template&id=31c8188d&scoped=true&"
import script from "./DxfLayersList.vue?vue&type=script&lang=js&"
export * from "./DxfLayersList.vue?vue&type=script&lang=js&"
import style0 from "./DxfLayersList.vue?vue&type=style&index=0&id=31c8188d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c8188d",
  null
  
)

export default component.exports